var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.75,
    height: 6.75,
    fill: "none",
    viewBox: "0 0 11.75 6.75"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD166",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "m.875.875 5 5 5-5"
  })));
};
export default SvgChevron;